export default __webpack_public_path__ + "static/media/staff-matthew-grainger.fc4d3026.jpg";